import React from 'react';
import HeaderMainPage from '../../Auth/Header/HeaderMainPage';
import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import { useNavigate } from 'react-router-dom';
import { EndPoints } from '../../../utils/apiEndpoints';
import { useUserStore } from '../../../store/useUserStore';
import { useLanguageStore } from '../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { darkModeBackgroudInputs } from '../../../utils/constants';

export const NotFound = () => {
    const navigation = useNavigate();

    const { darkMode } = useDarkModeStore();
    const { user } = useUserStore();
    const { language } = useLanguageStore();

    const textColor = '#b3b4b5';

    const NotFoundContent = () => {
        return <div
            className='d-flex align-items-center justify-content-center w-100 position-relative'
            style={{ height: 'calc(100vh - 200px)', background: darkMode ? darkModeBackgroudInputs : 'transparent' }}
        >
            <div className='d-flex flex-column fw-bold justify-content-center align-items-center' style={{ fontSize: 28, zIndex: 2 }}>
                <div className='d-flex align-items-center justify-content-center' style={{ color: textColor, fontSize: 150 }}>404</div>
                <span className='text-center' style={{ color: textColor }}>{language['Error404NotFound1']}</span>
                <span style={{ color: textColor }}>{language['Error404NotFound2']}</span>
                <span className='text-center mt-5'>
                    <button
                        className='btn btn-scale'
                        onClick={() => user ? navigation('/') : navigation(EndPoints.LOGIN)}
                        style={{ borderRadius: 20, maxWidth: 300, width: 280, background: '#0B6BCB', color: 'white', padding: '10px 5px' }}
                    >
                        {language['BackToHomepage']} <ArrowRightAltOutlinedIcon className="ms-1" />
                    </button>
                </span>
            </div>
        </div>
    }

    return (user
        ? <div><NotFoundContent /></div>
        : <div className='w-100'>
            <HeaderMainPage />
            <NotFoundContent />
        </div>

    );
}

export default NotFound;

